module.exports = __webpack_public_path__ + "static/media/ic-mobile-verification.45bf9634.svg";